module.exports = __webpack_public_path__ + "img/cerveza.a4a36668.png";